export const UPDATE_WALLET = "UPDATE_WALLET";
export const SET_MODAL_CONNECT = "SET_MODAL_CONNECT";
export const UPDATE_MAIN_TOKEN_BALANCE = "UPDATE_MAIN_TOKEN_BALANCE";
export const RESET_WALLET_STATE = "RESET_WALLET_STATE";
export const UPDATE_TOKEN_BALANCES = "UPDATE_TOKEN_BALANCES";
export const UPDATE_AUTH_TOKEN = "UPDATE_AUTH_TOKEN";
export const UPDATE_SHOW_MODAL_CONNECT = "UPDATE_SHOW_MODAL_CONNECT";
export const UPDATE_TO_CONNECT_CHAIN = "UPDATE_TO_CONNECT_CHAIN";
